import { AuthorizationMutationTypes } from './types';

export const mutations = {
    [AuthorizationMutationTypes.SetUserAuthStatus](state, {status}) {
        return state.auth = status
    },
}